import usePrintPDF, { STATUS } from './usePrintPDF';

export { STATUS };

export default usePrintPDF;
